import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '@app/store/root-state';
import { filter, map } from 'rxjs/operators';
import { fetchAllFences, postFence } from '@app/store/faxe/fences/fence.actions';
import { sortedMap, isNotEmpty } from '@app/fremework/functions';
import { Observable } from 'rxjs';
import { selectFenceByRaceGuid } from '@app/store/faxe/fences/fence.selectos';
import { FenceRace } from '@app/store/faxe/fences/model/fence-race';

@Injectable({
  providedIn: 'root'
})
export class FenceFacadeService {

  constructor(private store: Store<RootState>) {
  }

  fetchFence(raceGuid: string, issuer: string): Observable<FenceRace[]> {
    this.store.dispatch(
      fetchAllFences(
        { raceGuid: raceGuid, issuerStack: [issuer] }));

    return this.store.pipe(
      select(selectFenceByRaceGuid(raceGuid)),
      filter((data) => isNotEmpty(data)));
  }

  fetchFenceClassMap(raceGuid: string, issuer: string): Observable<Map<string, FenceRace[]>> {
    this.store.dispatch(
      fetchAllFences(
        { raceGuid, issuerStack: [issuer] }));

    return this.store.pipe(
      select(selectFenceByRaceGuid(raceGuid)),
      filter((data) => isNotEmpty(data)),
      map(fences => sortedMap(
        fences,
        (fence) => fence.raceClassGuid,
        (f) => f.renumberedSequence)));
  }

  addFence(fences: FenceRace[], issuer: string): void {
    this.store.dispatch(
      postFence(
        { fences, issuerStack: [issuer] }));
  }

}
